const joinClasses = (classes: any[]) => {
  const filtered = classes.filter(Boolean);
  return filtered.join(" ");
};

export default joinClasses;
